import VesselForecast from './vessel-forecast.container'

export default VesselForecast